export const version = "logger/5.1.0";
//# sourceMappingURL=_version.js.map